import { render, staticRenderFns } from "./TablaDatosControlFarmacias.vue?vue&type=template&id=3d933480&scoped=true"
import script from "./TablaDatosControlFarmacias.vue?vue&type=script&lang=js"
export * from "./TablaDatosControlFarmacias.vue?vue&type=script&lang=js"
import style0 from "./TablaDatosControlFarmacias.vue?vue&type=style&index=0&id=3d933480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d933480",
  null
  
)

export default component.exports